import React from "react";
import { DisplayFilter } from "@me8eon/filters";
import { mimeTypeIconMap, MimeTypeString, mimeTypeStrings } from "./file.type.filter";
import { useTranslation } from "@me8eon/translation";
import "./simple.mime.type.scss";
import { Icon } from "@me8eon/icons";
export const SimpleDisplayMimeTypeFilter: DisplayFilter<MimeTypeString> = ({ rootId, filterOps }) => {
    const [filters, setFilters] = filterOps;
    const translate = useTranslation();

    return (
        <div role="radiogroup" aria-labelledby={`${rootId}-label`} data-testid={`${rootId}-mime-type-filter`}>
            {mimeTypeStrings.map((mimeType) => (
                <label
                    htmlFor={mimeType}
                    key={mimeType}
                    className="filter-opt"
                    data-testid={`${rootId}-label-${mimeType}`}
                >
                    <div className="current-opt-left">
                        <input
                            id={mimeType}
                            type="radio"
                            checked={filters === mimeType}
                            name="advance-page-filters"
                            onChange={() => setFilters(mimeType)}
                            data-testid={`${rootId}-radio-${mimeType}`}
                        />
                        <Icon
                            name={mimeTypeIconMap[mimeType]}
                            style={{ height: "auto", width: "auto" }}
                        />
                        <span data-testid={`${rootId}-label-text-${mimeType}`}>
                            {translate(`filterPage.dataSources.${mimeType}`)}
                        </span>
                    </div>
                </label>
            ))}
        </div>
    );
};
